import { render, staticRenderFns } from "./grid-works.component.vue?vue&type=template&id=20fd3f92&"
import script from "./grid-works.component.vue?vue&type=script&lang=js&"
export * from "./grid-works.component.vue?vue&type=script&lang=js&"
import style0 from "./grid-works.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports